import React from 'react';
import { Card, CardBody, CardHeader, Nav, NavItem, NavLink } from 'reactstrap';
import { Route, Switch, Redirect } from 'react-router';
import { NavLink as Link } from 'react-router-dom';
import PatientReportTab from './PatientTab';
import OrganizationReportTab from './OrganizationTab';

const ReportCardComponent = () => (
  <Card>
    <CardHeader>
      <Nav tabs className="card-header-tabs">
        <NavItem>
          <NavLink tag={Link} to="/report/organization">
            Organization
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink disabled tag={Link} to="/report/patient">
            Patient
          </NavLink>
        </NavItem>
      </Nav>
    </CardHeader>
    <CardBody>
      <Switch>
        <Redirect exact from="/report" to="/report/organization" />
        <Route path="/report/organization" component={OrganizationReportTab} />
        <Route path={'/report/patient'} component={PatientReportTab} />
      </Switch>
    </CardBody>
  </Card>
);

export default ReportCardComponent;
